import type { Build, IApp } from '@todesktop/shared';
import {
  doc,
  getDoc,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
} from 'firebase/firestore';
import firestore from './firestore';
import { readDocumentSnapshot, readQueryDocument } from './firestoreData';
import getBuildById from './getBuildById';

export default async function getLatestReleasedBuild({
  appId,
  userId,
}: {
  appId: string;
  userId: string;
}): Promise<Build | undefined> {
  const appRef = doc(firestore, `users/${userId}/applications/${appId}`);
  const appSnapshot = await getDoc(appRef);
  const app = readDocumentSnapshot<IApp>(appSnapshot);

  if (!app) {
    throw new Error(`Application with ID of ${appId} doesn't exist.`);
  }

  if (app.meta?.latestReleaseBuildId) {
    return (
      (await getBuildById({
        buildId: app.meta?.latestReleaseBuildId,
        appId,
        userId,
      })) || undefined
    );
  }

  const buildsQuery = query(
    collection(firestore, `users/${userId}/applications/${appId}/builds`),
    orderBy('releasedAt', 'desc'),
    limit(1),
  );
  const buildsResult = await getDocs(buildsQuery);

  return buildsResult.empty
    ? undefined
    : readQueryDocument<Build>(buildsResult.docs[0]);
}
